/**
 * Portal 菜单处理
 * 医学会：接口返回父级菜单列表，按 colCode 合并本地子菜单
 * 产品：usermagazinecentermenu 返回 code 列表，过滤本地菜单
 */

import { NEW_MENU_MAP } from '../config/newMenus'

export function extractMenuListFromResponse(res) {
  const body = res?.data
  if (Array.isArray(body)) return body
  if (Array.isArray(body?.data)) return body.data
  return []
}

/** 医学会：按接口返回顺序组装侧栏菜单 */
export function buildMedicalMenu(portalList) {
  return portalList
    .map((row) => {
      const local = NEW_MENU_MAP[row.colCode]
      if (!local) return null
      const menu = JSON.parse(JSON.stringify(local))
      if (row.columnName) menu.columnName = row.columnName
      if (row.title != null) menu.title = row.title
      if (row.path) menu.path = row.path
      if (row.single === true || row.single === 'true') menu.single = true
      if (row.single === false || row.single === 'false') menu.single = false
      return menu
    })
    .filter(Boolean)
}

/** 产品：按 code 过滤菜单（含旧菜单 code 与新菜单 colCode） */
export function filterMenuByCodes(menus, allowedCodes) {
  const allowed = new Set(allowedCodes)
  const list = JSON.parse(JSON.stringify(menus))

  for (let i = list.length - 1; i >= 0; i--) {
    const item = list[i]
    const key = item.colCode || item.code

    if (item.childrenList?.length) {
      if (allowed.has(key)) continue
      item.childrenList = item.childrenList.filter((child) =>
        allowed.has(child.colCode || child.code)
      )
      if (!item.childrenList.length) list.splice(i, 1)
    } else if (!allowed.has(key)) {
      list.splice(i, 1)
    }
  }
  return list
}

export function findFirstRoutableMenu(menus) {
  if (!menus?.length) return null
  for (const item of menus) {
    if (item.single && item.path) {
      return { path: item.path, index: item.index }
    }
    const child = item.childrenList?.find((c) => c.path)
    if (child) {
      return { path: child.path, index: child.index }
    }
  }
  return null
}

export function getMenuPermissionCode(item) {
  return item?.colCode || item?.code || null
}
